/* Collezione e ricerca: «Nascondi esauriti» e invio automatico dell'ordinamento. */
(function () {
  'use strict';
  var K = 'bt-hide-soldout';
  var sw = document.querySelector('[data-hide-soldout]');

  function apply(on) {
    sw.setAttribute('aria-checked', on ? 'true' : 'false');
    document.querySelectorAll('[data-soldout]').forEach(function (el) { el.hidden = on; });
    try { sessionStorage.setItem(K, on ? '1' : '0'); } catch (e) {}
  }

  if (sw) {
    /* Con il filtro nativo di disponibilità (data-href) l'interruttore apre la stessa collezione filtrata: vale su tutte le pagine
       e lo stato sta nell'indirizzo. Senza filtro nativo (ricerca) resta il nascondere sulla pagina aperta. */
    var href = sw.getAttribute('data-href');
    sw.addEventListener('click', function () {
      if (href) { window.location.href = href; return; }
      apply(sw.getAttribute('aria-checked') !== 'true');
    });
    var saved = null;
    if (!href) {
      try { saved = sessionStorage.getItem(K); } catch (e) {}
      if (saved === '1') apply(true);
    }
  }

  document.querySelectorAll('select[data-autosubmit]').forEach(function (s) {
    s.addEventListener('change', function () {
      var f = s.form;
      if (f) { if (f.requestSubmit) f.requestSubmit(); else f.submit(); }
    });
  });
})();
